import { Control, Controller, UseFormSetValue, UseFormWatch } from 'react-hook-form'
import React from 'react'
import { t } from 'ttag'
import { FormData } from '../../ChallengeAdmin'
import YumField from '../../../../components/YumInput/YumInput'
import InputAdornment from '@material-ui/core/InputAdornment'

import { ReactComponent as DailyGoalActiveIcon } from '../../../../assets/v3/icons/daily-goal-active.svg'
import { ReactComponent as DailyGoalInactiveIcon } from '../../../../assets/v3/icons/daily-goal-inactive.svg'
import { getCustomUnitShortTextById } from '../../../../services/CustomTypes'
import { isAutomatedType } from '../../../../common/helpers/challenges'
import { dailyMaxLabel } from '../../../ChallengeInfo/ChallengeInfo'

interface ChallengePointsUnitFieldProps {
  control: Control<FormData, any>
  watch: UseFormWatch<FormData>
  name: any
  dailyGoalFieldName: any
  unitFieldName: any
  dailyGoalError: boolean
}

export default function ChallengePointsDailyMaxField(props: ChallengePointsUnitFieldProps) {
  const { control, watch, name, dailyGoalFieldName, unitFieldName, dailyGoalError } = props

  const manualEntryEnabled = watch('manualEntryEnabled')
  const simpleManualEntry = watch(name)
  const unit = watch(unitFieldName)
  const unitName = getCustomUnitShortTextById(unit)

  const required = (manualEntryEnabled || !isAutomatedType(unit)) && simpleManualEntry
  const showError = required && dailyGoalError

  return (
    <Controller
      name={dailyGoalFieldName}
      rules={{
        min: 1,
        required,
      }}
      control={control}
      render={({ field: { ref, ...otherField } }) => (
        <YumField
          shrink
          label={dailyMaxLabel + (!required ? '' : ' *')}
          type="number"
          inputProps={{ inputMode: 'numeric' }}
          inputRef={ref}
          error={showError}
          onWheel={(e: { target: { blur: () => any } }) => e.target.blur()}
          InputProps={
            unitName && {
              endAdornment: (
                <InputAdornment style={{ flexShrink: 0, pointerEvents: 'none' }} position="end" disableTypography>
                  {unitName}
                </InputAdornment>
              ),
            }
          }
          startIcon={DailyGoalActiveIcon}
          startIconInactive={DailyGoalInactiveIcon}
          {...otherField}
        />
      )}
    />
  )
}
